import React, { useState, useEffect } from 'react';
import { getActionLogs } from '../services/api';

const ACTION_CONFIG = {
  login:                 { label: 'Connexion',                  color: '#6b7280', bg: 'rgba(107,114,128,0.12)', icon: '🔐' },
  page_visite:           { label: 'Page consultée',             color: '#8b92a5', bg: 'rgba(139,146,165,0.10)', icon: '👁' },
  appel1:                { label: '1er appel sans succès',       color: '#b45309', bg: 'rgba(180,83,9,0.12)',   icon: '📵' },
  appel2:                { label: '2ème appel sans succès',      color: '#c2410c', bg: 'rgba(194,65,12,0.12)',  icon: '📵' },
  proposition:           { label: 'Proposition RDV',            color: '#1d4ed8', bg: 'rgba(29,78,216,0.12)', icon: '📅' },
  confirmer:             { label: 'RDV confirmé — Planifiée',   color: '#15803d', bg: 'rgba(21,128,61,0.12)', icon: '✅' },
  cr_valide:             { label: 'CR validé',                  color: '#15803d', bg: 'rgba(21,128,61,0.12)', icon: '✅' },
  cr_rejete:             { label: 'CR rejeté',                  color: '#b91c1c', bg: 'rgba(185,28,28,0.12)', icon: '❌' },
  cr_remis_en_attente:   { label: 'CR remis en attente',        color: '#b45309', bg: 'rgba(180,83,9,0.12)',  icon: '↩' },
  suppression_wo:        { label: 'Demande suppression WO SD',  color: '#7e22ce', bg: 'rgba(126,34,206,0.12)', icon: '🗑' },
  sav_export_zoho:       { label: 'Export SAV → Zoho',          color: '#0369a1', bg: 'rgba(3,105,161,0.12)', icon: '🚨' },
  import_commande_cree:  { label: 'Import commande — Créée',    color: '#0d6b3a', bg: 'rgba(13,107,58,0.12)', icon: '📦' },
  import_commande_maj:   { label: 'Import commande — MAJ',      color: '#0369a1', bg: 'rgba(3,105,161,0.12)', icon: '📦' },
  dropbox_archive:       { label: 'Archivage Dropbox',          color: '#6b7280', bg: 'rgba(107,114,128,0.12)', icon: '🗄' },
  email_envoye:          { label: 'Email envoyé',               color: '#0369a1', bg: 'rgba(3,105,161,0.12)', icon: '✉' },
  email_repondu:         { label: 'Réponse email',              color: '#0891b2', bg: 'rgba(8,145,178,0.12)', icon: '↩✉' },
  commentaire_interne:   { label: 'Commentaire interne',        color: '#6b7280', bg: 'rgba(107,114,128,0.12)', icon: '💬' },
  commentaire_planif:    { label: 'Commentaire planif',         color: '#6b7280', bg: 'rgba(107,114,128,0.12)', icon: '💬' },
  commentaire_valea:     { label: 'Commentaire VALEA',          color: '#6b7280', bg: 'rgba(107,114,128,0.12)', icon: '💬' },
  changer_stage:         { label: 'Changement statut',          color: '#7c3aed', bg: 'rgba(124,58,237,0.12)', icon: '🔄' },
  report_rdv_applique:   { label: 'Report RDV appliqué',       color: '#1d4ed8', bg: 'rgba(29,78,216,0.12)', icon: '📅' },
  sav_comment_airtable:  { label: 'Commentaire SAV Airtable',  color: '#6b7280', bg: 'rgba(107,114,128,0.12)', icon: '💬' },
  update_contact:        { label: 'Mise à jour contact',        color: '#0369a1', bg: 'rgba(3,105,161,0.12)', icon: '👤' },
  // Ces neuf-là s'écrivaient déjà dans le journal sans y avoir de libellé :
  // la page retombait sur la clé brute, « cr_devis_modifie » au milieu de
  // phrases françaises. Les quatre premières arrivent vraiment — 16 entrées
  // depuis le 31 août — les autres attendent leur premier usage.
  cr_pieces:             { label: 'Pièces du CR modifiées',    color: '#0369a1', bg: 'rgba(3,105,161,0.12)', icon: '📎' },
  cr_modifie:            { label: 'CR modifié',                color: '#b45309', bg: 'rgba(180,83,9,0.12)',  icon: '✎' },
  cr_devis_modifie:      { label: 'Devis du CR modifié',       color: '#b45309', bg: 'rgba(180,83,9,0.12)',  icon: '💶' },
  role_create:           { label: 'Rôle créé',                 color: '#7e22ce', bg: 'rgba(126,34,206,0.12)', icon: '🛡' },
  role_update:           { label: 'Rôle modifié',              color: '#7e22ce', bg: 'rgba(126,34,206,0.12)', icon: '🛡' },
  role_delete:           { label: 'Rôle supprimé',             color: '#b91c1c', bg: 'rgba(185,28,28,0.12)', icon: '🛡' },
  account_create:        { label: 'Compte créé',               color: '#15803d', bg: 'rgba(21,128,61,0.12)', icon: '👤' },
  account_update:        { label: 'Compte modifié',            color: '#0369a1', bg: 'rgba(3,105,161,0.12)', icon: '👤' },
  portail_covage_reglages: { label: 'Réglages portail Covage', color: '#6b7280', bg: 'rgba(107,114,128,0.12)', icon: '⚙' },
};

function fmt(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('fr-FR', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
}

function fmtDay(iso) {
  if (!iso) return '';
  return new Date(iso).toLocaleDateString('fr-FR', {
    weekday: 'long', day: 'numeric', month: 'long', year: 'numeric',
  });
}

function groupByDay(logs) {
  const groups = {};
  logs.forEach(log => {
    const day = log.at ? log.at.split('T')[0] : 'inconnu';
    if (!groups[day]) groups[day] = [];
    groups[day].push(log);
  });
  return groups;
}

export default function Logs() {
  const [logs, setLogs]       = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState('');
  const [filterUser, setFilterUser] = useState('');
  const [filterAction, setFilterAction] = useState('');
  const [hidePageVisits, setHidePageVisits] = useState(false);

  useEffect(() => {
    setLoading(true);
    getActionLogs()
      .then(d => setLogs(d.logs || []))
      .catch(() => setError('Erreur chargement des logs'))
      .finally(() => setLoading(false));
  }, []);

  const users = [...new Set(logs.map(l => l.user_name).filter(Boolean))].sort();

  const filtered = logs.filter(l => {
    if (filterUser && l.user_name !== filterUser) return false;
    if (filterAction && l.action !== filterAction) return false;
    if (hidePageVisits && l.action === 'page_visite') return false;
    return true;
  });

  const grouped = groupByDay(filtered);
  const days = Object.keys(grouped).sort((a, b) => b.localeCompare(a));

  return (
    <>
      <div className="topbar">
        <div>
          <div className="topbar-title">Logs d'activité</div>
          <div style={{ fontSize: 12, color: 'var(--text3)', marginTop: 2 }}>
            Actions effectuées par les comptes conduite d'activité
          </div>
        </div>
        <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 8 }}>
          <button className="btn btn-secondary btn-sm" onClick={() => {
            setLoading(true);
            getActionLogs().then(d => setLogs(d.logs || [])).catch(() => {}).finally(() => setLoading(false));
          }}>↻ Actualiser</button>
        </div>
      </div>

      {/* Filtres */}
      <div style={{ padding: '10px 24px', borderBottom: '1px solid var(--border)', background: 'var(--bg2)', display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
        <span style={{ fontSize: 11, color: 'var(--text3)', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.06em' }}>Filtres</span>

        <select
          value={filterUser}
          onChange={e => setFilterUser(e.target.value)}
          className="form-input"
          style={{ fontSize: 12, padding: '4px 8px', width: 180 }}
        >
          <option value="">Tous les utilisateurs</option>
          {users.map(u => <option key={u} value={u}>{u}</option>)}
        </select>

        <select
          value={filterAction}
          onChange={e => setFilterAction(e.target.value)}
          className="form-input"
          style={{ fontSize: 12, padding: '4px 8px', width: 200 }}
        >
          <option value="">Toutes les actions</option>
          {Object.entries(ACTION_CONFIG).map(([k, v]) => (
            <option key={k} value={k}>{v.icon} {v.label}</option>
          ))}
        </select>

        <label style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 12, color: 'var(--text2)', cursor: 'pointer', userSelect: 'none' }}>
          <input
            type="checkbox"
            checked={hidePageVisits}
            onChange={e => setHidePageVisits(e.target.checked)}
            style={{ accentColor: 'var(--accent)', cursor: 'pointer' }}
          />
          Masquer pages consultées
        </label>

        {(filterUser || filterAction) && (
          <button
            className="btn btn-ghost btn-sm"
            onClick={() => { setFilterUser(''); setFilterAction(''); }}
            style={{ fontSize: 11 }}
          >✕ Effacer</button>
        )}

        <span style={{ marginLeft: 'auto', fontSize: 11, color: 'var(--text3)' }}>
          {filtered.length} entrée{filtered.length > 1 ? 's' : ''}
        </span>
      </div>

      <div style={{ flex: 1, overflow: 'auto', padding: '20px 24px' }}>
        {loading && (
          <div style={{ textAlign: 'center', padding: 40, color: 'var(--text3)' }}>Chargement…</div>
        )}
        {error && (
          <div style={{ padding: '12px 16px', background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 8, color: '#ef4444', fontSize: 13 }}>{error}</div>
        )}
        {!loading && !error && filtered.length === 0 && (
          <div style={{ textAlign: 'center', padding: 60, color: 'var(--text3)', fontSize: 14 }}>Aucun log trouvé</div>
        )}

        {!loading && days.map(day => (
          <div key={day} style={{ marginBottom: 28 }}>
            {/* Séparateur jour */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--text2)', textTransform: 'capitalize' }}>
                {fmtDay(grouped[day][0]?.at)}
              </div>
              <div style={{ flex: 1, height: 1, background: 'var(--border)' }} />
              <div style={{ fontSize: 11, color: 'var(--text3)', fontWeight: 600 }}>
                {grouped[day].length} action{grouped[day].length > 1 ? 's' : ''}
              </div>
            </div>

            {/* Entrées du jour */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
              {grouped[day].map(log => {
                const cfg = ACTION_CONFIG[log.action] || { label: log.action, color: '#8b92a5', bg: 'rgba(139,146,165,0.12)', icon: '•' };
                return (
                  <div key={log.id} style={{
                    display: 'flex', alignItems: 'flex-start', gap: 12,
                    padding: '10px 14px', borderRadius: 10,
                    background: 'var(--bg2)', border: '1px solid var(--border)',
                  }}>
                    {/* Heure */}
                    <div style={{ fontSize: 12, color: 'var(--text3)', fontFamily: 'var(--mono)', minWidth: 50, paddingTop: 1 }}>
                      {log.at ? new Date(log.at).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }) : '—'}
                    </div>

                    {/* Badge action */}
                    <span style={{
                      fontSize: 11, fontWeight: 700, padding: '2px 8px', borderRadius: 20, whiteSpace: 'nowrap', flexShrink: 0,
                      color: cfg.color, background: cfg.bg,
                    }}>
                      {cfg.icon} {cfg.label}
                    </span>

                    {/* Utilisateur */}
                    <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--text)', minWidth: 130, flexShrink: 0 }}>
                      {log.user_name || '—'}
                      {log.role === 'conducteur' && (
                        <span style={{ marginLeft: 5, fontSize: 10, color: 'var(--text3)', fontWeight: 400 }}>CA</span>
                      )}
                    </div>

                    {/* Détails */}
                    <div style={{ fontSize: 12, color: 'var(--text2)', flex: 1, minWidth: 0 }}>
                      {log.action === 'login' ? (
                        <span style={{ color: 'var(--text3)' }}>Connexion au panel admin</span>
                      ) : log.action === 'page_visite' ? (
                        <span style={{ color: 'var(--text3)' }}>
                          {log.page || '—'}
                        </span>
                      ) : (log.action === 'email_envoye' || log.action === 'email_repondu') ? (
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center' }}>
                          {log.boite && (
                            <span style={{ fontSize: 11, padding: '1px 6px', borderRadius: 10, background: 'rgba(3,105,161,0.1)', color: '#0369a1', fontWeight: 600 }}>{log.boite}</span>
                          )}
                          {log.destinataire && (
                            <span style={{ color: 'var(--text2)', fontSize: 11 }}>→ {log.destinataire}</span>
                          )}
                          {log.sujet && (
                            <span style={{ color: 'var(--text3)', fontSize: 11, fontStyle: 'italic', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 280 }}>
                              "{log.sujet}"
                            </span>
                          )}
                        </div>
                      ) : (
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center' }}>
                          {log.dossier_ref && (
                            <span style={{ fontFamily: 'var(--mono)', fontWeight: 700, color: 'var(--accent)', fontSize: 12 }}>
                              {log.dossier_ref}
                            </span>
                          )}
                          {log.client && (
                            <span style={{ color: 'var(--text2)', fontSize: 11 }}>{log.client}</span>
                          )}
                          {log.technicien && (
                            <span style={{ color: 'var(--text3)', fontSize: 11 }}>👷 {log.technicien}</span>
                          )}
                          {log.resultat && (
                            <span style={{ color: 'var(--text3)', fontSize: 11 }}>→ {log.resultat}</span>
                          )}
                          {log.motif && (
                            <span style={{ color: '#b91c1c', fontSize: 11 }}>Motif : {log.motif}</span>
                          )}
                          {log.date_rdv && (
                            <span style={{ color: 'var(--text2)', fontSize: 11 }}>
                              📅 {log.date_rdv.includes('T') ? fmt(log.date_rdv) : log.date_rdv}
                              {log.heure_rdv ? ` à ${log.heure_rdv}` : ''}
                            </span>
                          )}
                          {log.envoi_mail && (
                            <span style={{ color: '#16a34a', fontSize: 11, fontWeight: 600 }}>✉ Mail envoyé</span>
                          )}
                          {log.label && !log.dossier_ref && (
                            <span style={{ color: 'var(--text2)', fontSize: 11 }}>{log.label}</span>
                          )}
                          {log.fichiers && (
                            <span style={{ color: 'var(--text3)', fontSize: 10, fontFamily: 'var(--mono)' }}>{log.fichiers}</span>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
